import { render, staticRenderFns } from "./wow.vue?vue&type=template&id=08de4cb0&scoped=true&"
import script from "./wow.vue?vue&type=script&lang=js&"
export * from "./wow.vue?vue&type=script&lang=js&"
import style0 from "./wow.vue?vue&type=style&index=0&id=08de4cb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08de4cb0",
  null
  
)

export default component.exports